<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" class="mx-auto pb-0">
        <v-btn
          color="darktext"
          class="rounded-xxl text-none white--text px-4"
          @click="goBack"
        >
          <v-icon>mdi-chevron-left</v-icon>{{ $t('backToHub') }}
        </v-btn>
        <span
          class="float-right"
        >
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'HubOverview'}"
                @click="showHubOverview"
              >
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                class="accent--text"
                :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
                @click="showHubMembers"
              >
                <v-list-item-title>{{ $t('people') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
                @click="showHubOwners"
              >
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="text-h5 font-weight-bold pt-5" :align="mobile() ? 'center' : 'left'">
          {{ $t('peopleInHubTitle') }}
        </p>
        <p class="text-body-1 greytext--text d-none d-md-block">
          {{ $t('peopleInHubText') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'HubOverview'}"
            @click="showHubOverview"
          >
            {{ $t('overview') }}
          </v-list-item>          
          <v-list-item
            class="accent--text"
            :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
            @click="showHubMembers"
          >
            {{ $t('people') }}
          </v-list-item>
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
            @click="showHubOwners"
          >
            {{ $t('owners') }}
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="totalUsers > 0" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && usersInfo.currentPage == 1 && !loadingData && search == null"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyPeopleInHubTitle')"
          :page-text="$t('emptyPeopleInHubText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"

    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto mb-n7"
      >
        <div v-if="!loadingData && !mobile()" class="d-flex flex-wrap align-center">
          <v-checkbox
            v-model="selectedAll"
            @change="selectAllUsersFromPage($event)"
            :disabled="users.length == 0"
          ></v-checkbox>
          <v-menu
              offset-y
              rounded-lg
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="no-hover ml-n3"
                  :ripple="false"
                >
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list
                class="menulist-drawer"
                data-testid="menu-list"
              >
                <v-list-item @click="selectedAll = true, selectAllUsersFromPage(true)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('allFromThisPage') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedAll = false, selectAllUsersFromPage(false)" :disabled="users.length == 0">
                  <v-list-item-title>{{ $t('removeUsersNone') }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
            <v-btn 
              ref="submit"
              data-testid="remove-from-hub-button"
              type="submit"
              color="accent"
              min-width="100"
              elevation="0"
              class="rounded-xxl text-none px-4 submit ml-3" 
              @click.stop="showConfirmationDialogRemoveFromHub"
              :disabled="selectedUsersForRemoving.length == 0 || loadingRemovingMultipleUsersFromConnectedActivities"
              :loading="loadingRemovingMultipleUsers"
            >
              {{ $t('removeFromHub') }}
            </v-btn>
            <v-btn 
              ref="submit-plus"
              data-testid="remove-from-hub-and-activities-button"
              type="submit"
              color="accent"
              min-width="100"
              elevation="0"
              class="rounded-xxl text-none px-4 submit ml-5" 
              @click.stop="showConfirmationDialogRemoveFromHubAndConnectedActivities"
              :disabled="selectedUsersForRemoving.length == 0 || loadingRemovingMultipleUsers"
              :loading="loadingRemovingMultipleUsersFromConnectedActivities"
            >
              {{ $t('removeFromHubAndConnectedActivities') }}
            </v-btn>
        </div>
        <div v-if="!loadingData && mobile()" class="align-center">
          <v-row>
            <v-col cols="2" class="d-flex align-center justify-start align-self-end mb-n2">
              <v-checkbox
              v-model="selectedAll"
              @change="selectAllUsersFromPage($event)"
              hide-details
            ></v-checkbox>
            <v-menu
              offset-y
              rounded-lg
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="no-hover ml-n3 align-self-end"
                  :ripple="false"
                >
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list
                class="menulist-drawer"
                data-testid="menu-list"
              >
                <v-list-item @click="selectedAll = true, selectAllUsersFromPage(true)">
                  <v-list-item-title>{{ $t('allFromThisPage') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectedAll = false, selectAllUsersFromPage(false)">
                  <v-list-item-title>{{ $t('removeUsersNone') }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
            </v-col>
            <v-col cols="10" align="right">
              <v-btn 
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              elevation="0"
              class="rounded-xxl text-none px-4 submit mb-2 d-block" 
              @click.stop="showConfirmationDialogRemoveFromHub"
              :disabled="selectedUsersForRemoving.length == 0"
            >
              {{ $t('removeFromHub') }}
            </v-btn>
            <v-btn 
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              elevation="0"
              class="rounded-xxl text-none px-4 submit d-block text-wrap" 
              @click.stop="showConfirmationDialogRemoveFromHubAndConnectedActivities"
              :disabled="selectedUsersForRemoving.length == 0"
            >
              {{ $t('removeFromHubAndConnectedActivities') }}
            </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"  :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-3"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col
                cols="10"
                class="d-flex justify-left align-center"
              >
                <v-avatar
                  size="38"
                  class="mr-2 ml-4"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-hub"
                      router
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromHub'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromHub'), 
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                class="d-flex justify-left align-center"
              >
                <v-checkbox
                  class="mr-0 mb-0 mt-1 ml-4"
                  data-testid="remove-user-checkbox"
                  :input-value="selectedUsersForRemoving.includes(user.id) ? true : false"
                  hide-details
                  @change="selectUser($event, user)"
                ></v-checkbox>
              </v-col>
              <v-col
                md="5"
                class="d-flex justify-left align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
                <div class="ml-3">
                  <div class="text-body-2 grey--text justify-left">
                    {{ $t('name') }}
                  </div>
                  <div class="text-body-1 darktext--text">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </div>
                </div>
              </v-col>
              <v-col
                md="5"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-hub"
                      router
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromHub'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveUserFromHub'), 
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <ConfirmationDialog 
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-additonal-text="confirmationDialogAdditonalText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-user"
      @close="dialogVisibleRemoveUser=false, selectedUserForRemoving = null, confirmationDialogAdditonalText = ''"
      @proceedSubmit="selectedUserForRemoving != null ? removeUser(selectedUserForRemoving) : removeUsers()"
    />
    <PlusButtonWithLink
      data-testid="add-people-button"
      rounded="xxl"
      :link="link"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getPeopleInHub, removeUserFromHub,searchPeopleInHubMembers, removeUsersFromHub } from '../../api/hubApi'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import SearchBarExpanding from '../../components/SearchBarExpanding'

export default {
    components: {
        Pagination,
        PlusButtonWithLink,
        EmptyPage,
        AlertMessages,
        ConfirmationDialog,
        SearchBarExpanding
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: { 
                currentPage: 1,
                total: 0,
            },
            userId: window.$cookies.get('id'),
            hubId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertType:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            loadingData: false,
            dialogVisibleRemoveUser: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            link: {title: i18n.t('invitePeopleTitle'), route: '/hub/' + this.$route.params.id + '/share'},
            search: null,
            paginationKey: '',
            selectedUsersForRemoving: [],
            selectedAll: false,
            notSelected: false,
            selected: true,
            confirmationDialogAdditonalText: '',
            visitedUsers: [],
            selectedUserForRemoving: null,
            removeFromConnectedActivities: false,
            loadingRemovingMultipleUsers: false,
            loadingRemovingMultipleUsersFromConnectedActivities: false,
            totalUsers: 0
        }
    },
    watch:{
      selectedUsersForRemoving(){
        if(this.selectedUsersForRemoving.length == 0){
          this.selectedAll = false
        }else{
          this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
        }
      }
    },

    async created(){
        if(this.$route.params.successfullySharedHub){
            this.alertMsg = i18n.t('shareHubSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        this.loadingData = true
        await this.fetchPeopleInHub()
        this.loadingData = false
    },
    methods:{
       async searchPeople(keyword){
        this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchPeopleInHubMembers(this.hubId,keyword,this.pageNumber, this.size)
                  if(response){
                      if(response.status == 200){
                        this.selectedUsersForRemoving = []
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.searchPeople(keyword)
                        }else {
                          this.usersInfo = response.data.meta
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          this.visitedUsers.push(...response.data.data)
                          window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchPeopleInHub()
          this.search = null
          this.paginationKey = Date.now()
          return
        },
        async handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              await this.fetchPeopleInHub()
            }else {
              await this.searchPeople(this.search)
            }
            this.selectedAll = this.users.map(user => user.id).every(item => this.selectedUsersForRemoving.includes(item))
        },
        async fetchPeopleInHub(){
            try {
                const response = await getPeopleInHub(this.hubId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.fetchPeopleInHub()
                        }else {
                          this.usersInfo = response.data.meta
                          this.totalUsers = response.data.meta.total
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          this.visitedUsers.push(...response.data.data)
                          window.scrollTo(0,0)
                        }
                    }
                }            
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        showHubOverview(){
            if (this.$route.name != 'HubOverview') {
                this.$router.push({path: '/hub/'+ this.hubId +'/overview'})
            }
        },
        showHubMembers(){
            if (this.$route.name != 'PeopleInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/people'})
            }
        },
        showHubOwners(){
            if (this.$route.name != 'BoostersInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/owners'})
            }
        },
        goBack(){
            this.$router.push({path: '/hub/'+ this.hubId})
        },
        async removeUser(email){
            this.dialogVisibleRemoveUser = false
            try{
                let data = {
                    data: {
                        type: "hub-users", 
                        attributes: {
                            user_email: email
                        },
                    }
                }
                const response = await removeUserFromHub(this.hubId, data)
                if(response.status == 200) {
                    if(this.search == null){
                      await this.fetchPeopleInHub()
                    }else {
                      await this.searchPeople(this.search)
                    }

                    this.selectedUsersForRemoving = []
                    this.confirmationDialogAdditonalText = ''

                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeUserFromHubSuccess')
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
            this.selectedUserForRemoving = null
        },

        async removeUsers(){
            this.dialogVisibleRemoveUser = false
            this.removeFromConnectedActivities ? this.loadingRemovingMultipleUsersFromConnectedActivities = true : this.loadingRemovingMultipleUsers = true
            try{
                let data = {
                    data: {
                        type: "hub-users", 
                        attributes: {
                            users: this.selectedUsersForRemoving,
                            remove_from_connected_activities: this.removeFromConnectedActivities
                        },
                    }
                }
                const response = await removeUsersFromHub(this.hubId, data)
                if(response.status == 200) {
                    if(this.search == null){
                      await this.fetchPeopleInHub()
                    }else {
                      await this.searchPeople(this.search)
                    }
                    this.selectedUsersForRemoving = []
                    this.confirmationDialogAdditonalText = ''
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  this.removeFromConnectedActivities ? i18n.t('removeUsersFromHubAndConnectedActivitiesSuccess') : i18n.t('removeUsersFromHubSuccess')
                }
            } catch (e) {
                if(e.response){
                    this.confirmationDialogAdditonalText = ''
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
            this.removeFromConnectedActivities ? this.loadingRemovingMultipleUsersFromConnectedActivities = false : this.loadingRemovingMultipleUsers = false
        },

        selectAllUsersFromPage(event){
          if(event){
            this.users.forEach(user => {
              if(!this.selectedUsersForRemoving.includes(user.id)){
                this.selectedUsersForRemoving.push(user.id)
              }
            })
          }else {
            this.users.forEach(user => {
              this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
            })
          }
        },
        selectUser(event, user){
          if(event){
            if(!this.selectedUsersForRemoving.includes(user.id)){
              this.selectedUsersForRemoving.push(user.id)
            }
          }else{
            this.selectedUsersForRemoving = this.selectedUsersForRemoving.filter(item => item !== user.id)
          }
        },

        showConfirmationDialogRemoveFromHub(){
          this.removeFromConnectedActivities= false
          this.selectedUsersForRemoving.forEach(item => {
            const user = this.visitedUsers.find(user => user.id == item)
            this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">' + user.attributes.first_name + ' ' + user.attributes.last_name + '</p>'
          });
          this.dialogVisibleRemoveUser= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleRemoveUsersFromHub')
          this.confirmationDialogText= i18n.t('confirmationDialogTextRemoveUsersFromHub')
          this.confirmationDialogSubmitBtn= i18n.t('remove')
          this.confirmationDialogCancelBtn= i18n.t('no')
        },

        showConfirmationDialogRemoveFromHubAndConnectedActivities(){
          this.removeFromConnectedActivities = true
          this.selectedUsersForRemoving.forEach(item => {
            const user = this.visitedUsers.find(user => user.id == item)
            this.confirmationDialogAdditonalText = this.confirmationDialogAdditonalText + '<p class="ml-5 mb-0 text-truncate">' + user.attributes.first_name + ' ' + user.attributes.last_name + '</p>'
          });
          this.dialogVisibleRemoveUser= true
          this.confirmationDialogTitle= i18n.t('confirmationDialogTitleRemoveUsersFromHub')
          this.confirmationDialogText= i18n.t('confirmationDialogTextRemoveUsersFromHubAndConnectedActivities')
          this.confirmationDialogSubmitBtn= i18n.t('remove')
          this.confirmationDialogCancelBtn= i18n.t('no')
        },

    },
}
</script>
<style>
.v-text-field .v-input__append-inner {
  padding-left: 0px !important;
}
</style>
